// Azure exit WS9: find a gift certificate the way the admin portal does, and, once the door
// is live, create or update one. Reads run today; the forms stay hidden until then.
import React, { useEffect, useState } from 'react';
import { searchGiftCertificates } from '../services/api';
import { sessionHeaders } from '../services/auth';

async function door(action, body = {}) {
  const res = await fetch('/.netlify/functions/admin-write', { method: 'POST', headers: { 'Content-Type': 'application/json', ...sessionHeaders() }, body: JSON.stringify({ action, ...body }) });
  const data = await res.json().catch(() => ({}));
  return res.ok ? data : { ok: false, message: data.error || 'Could not save. Check the certificate before trying again.' };
}

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export default function GiftSearch() {
  const [f, setF] = useState({ code: '', nameTo: '', email: '', status: '', orderId: '' });
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');
  const [live, setLive] = useState(false);
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ amount: '', email: '', firstName: '', lastName: '', message: '' });

  useEffect(() => { door('card_features').then((r) => { if (r.live) setLive(true); }); }, []);

  const search = async (e) => {
    if (e) e.preventDefault();
    setError('');
    try { setRows(await searchGiftCertificates(f)); } catch (x) { setRows(null); setError('Could not search. Try again.'); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const act = async (action, body, ask) => {
    if (busy || !window.confirm(ask)) return;
    setBusy(true);
    const r = await door(action, { ...body, requestKey: crypto.randomUUID() });
    setBusy(false);
    setMessage(r.message || (r.ok ? 'Done.' : 'Not done.'));
    if (r.ok && rows) search();
  };

  return (
    <div className="card" style={{ padding: 16, marginBottom: 16 }}>
      <form onSubmit={search} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <input aria-label="Certificate" className="form-input" style={{ width: 170 }} placeholder="Certificate" value={f.code} onChange={set('code')} />
        <input aria-label="Name" className="form-input" style={{ width: 150 }} placeholder="Recipient name" value={f.nameTo} onChange={set('nameTo')} />
        <input aria-label="Email" className="form-input" style={{ width: 190 }} placeholder="Email" value={f.email} onChange={set('email')} />
        <input aria-label="Order" className="form-input" style={{ width: 110 }} placeholder="Order" value={f.orderId} onChange={set('orderId')} />
        <select aria-label="Status" className="form-input" style={{ width: 130 }} value={f.status} onChange={set('status')}>
          <option value="">All</option><option value="ACTIVE">Active</option><option value="PARTIAL">Partial</option><option value="REDEEMED">Redeemed</option><option value="DISABLED">Disabled</option><option value="NOTAUTHORIZED">Not authorized</option>
        </select>
        <button className="btn btn-primary" type="submit">Search</button>
      </form>
      {error && <div role="alert" style={{ color: 'var(--red)', marginTop: 8 }}>{error}</div>}
      {rows && (
        <table className="trans-table" style={{ marginTop: 12 }}>
          <thead><tr><th>Certificate</th><th>To</th><th>Email</th><th>Amount</th><th>Remaining</th><th>Status</th><th>Expires</th><th>Order</th>{live && <th>Remaining</th>}</tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={8}>No certificates found.</td></tr>}
            {rows.map((g) => (
              <tr key={g.id}>
                <td>{g.certificateNumber}</td><td>{g.nameTo}</td><td>{g.recipientEmail}</td><td>{money(g.amount)}</td><td>{money(g.remaining)}</td><td>{g.status}</td>
                <td>{g.expiryDate ? new Date(g.expiryDate).toLocaleDateString() : ''}</td><td>{g.issuedOnOrderId || ''}</td>
                {live && <td><button className="btn btn-outline" disabled={busy} onClick={() => { const v = window.prompt('New remaining balance', Number(g.remaining || 0).toFixed(2)); if (v !== null) act('gift_update', { giftId: g.id, giftNumber: g.certificateNumber, amount: Number(g.amount).toFixed(2), remaining: v.trim() }, `Set ${g.certificateNumber} to $${v}?`); }}>Set</button></td>}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {live && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginTop: 12 }}>
          {[['amount', 'Amount', 90], ['firstName', 'First name', 120], ['lastName', 'Last name', 120], ['email', 'Recipient email', 190], ['message', 'Message', 220]].map(([k, label, width]) => (
            <input key={k} aria-label={label} className="form-input" style={{ width }} placeholder={label} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
          ))}
          <button className="btn btn-primary" disabled={busy || !form.amount} onClick={() => act('gift_create', form, `Create a $${form.amount} certificate?`)}>Create</button>
          <button className="btn btn-outline" disabled={busy} onClick={async () => {
            const count = window.prompt('How many codes?'); const amount = count && window.prompt('Amount on each?');
            if (!amount) return;
            const r = await door('gift_codes', { requestKey: crypto.randomUUID(), count, amount, issueDate: new Date().toISOString(), expiryDate: new Date(Date.now() + 365 * 864e5).toISOString() });
            setMessage(r.ok ? r.codes.join(', ') : r.message);
          }}>Bulk codes</button>
          <button className="btn btn-outline" disabled={busy} onClick={async () => {
            const certificateNumber = window.prompt('Certificate number'); const giftCard = certificateNumber && window.prompt('Printed card number');
            if (!giftCard) return;
            const r = await door('gift_change_card', { requestKey: crypto.randomUUID(), certificateNumber, giftCard });
            setMessage(r.ok ? 'Done.' : r.message);
          }}>Printed card</button>
        </div>
      )}
      {message && <div role="status" style={{ marginTop: 8, fontWeight: 700 }}>{message}</div>}
    </div>
  );
}